import { useParams } from 'react-router-dom'
import { AdminTitle } from '../../../../store/reducers/site';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addShopAdress } from "../../../../store/actions/shopAction";
import { errorHelper, Loader } from '../../../../utils/tools';
import { validationAdress, formAdress } from './shopValidationSchema';
import { useFormik} from 'formik';
import Divider from '@mui/material/Divider' ;
import FormHelperText from '@mui/material/FormHelperText';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';



import {
  
    Button,
    ButtonGroup
  

} from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';


const AddShopAdress = () => {
    let { id } = useParams();
    

    // redux
    const shop = useSelector(state=>state.shopReducer);
 
    const dispatch = useDispatch();

    
    let navigate = useNavigate();
    let imgUrl='/dashboard/shop/continfo/'+id;

   

    const formik = useFormik({
        enableReinitialize:true,
        initialValues: formAdress,
        validationSchema:validationAdress,
        onSubmit:(values)=>{

            let myArray = id.split("_");
       
 
            let id1= Number(myArray[0]);
            let trns= Number(myArray[1]);
           
            console.log("111111111111111");
            console.log(values)
            console.log(id1)
            
            console.log("666666666666666666");
            values.shopId=id1;
            values.area2=values.area;

            dispatch(addShopAdress(values))
            .unwrap()
            .then((response)=>{
       
                if(response!=null)
                {
                  
                    if(response.status==='ok')
                    {
                   //const id=response.id

                   console.log("55555555");
                   console.log(response)
                   //console.log(id)
                   
                   console.log("666666666666666666");
                
                  
                 //navigate(`/dashboard/shop/continfo/${id}`)
                 navigate(`/dashboard/shop/continfo/${id}`, { replace: true }); 
                    }
                }


                
            })
        }
    })

   



    useEffect(()=>{
        
     // dispatch(getAllategory({}))
        //dispatch(getShopSubCategory({}))
        
    },[])
   

    return(
        <>
        
        <AdminTitle title="Add Adress"/>
        <form className='mt-3 news_form' onSubmit={formik.handleSubmit}>

        <div className='form-group'>
                <TextField
                    style={{ width:'100%'}}
                    name="line1"
                    label="Line 1 "
                    variant="outlined"
                    {...formik.getFieldProps('line1')}
                    {...errorHelper(formik,'line1')}
                    


                  
                   
                />
            </div>

            <div className='form-group'>
                <TextField
                    style={{ width:'100%'}}
                    name="line2"
                    label="Line 2 "
                    variant="outlined"
                    {...formik.getFieldProps('line2')}
                    {...errorHelper(formik,'line2')}


                  
                   
                />
            </div>

            <div className='form-group'>
                <TextField
                    style={{ width:'100%'}}
                    name="area"
                    label="Area "
                    variant="outlined"
                    {...formik.getFieldProps('area')}
                    {...errorHelper(formik,'area')}
                  />
            </div>

            <div className='form-group'>
                <TextField
                    style={{ width:'100%'}}
                    name="pincode"
                    label="ENTER YOUR PINCODE "
                    variant="outlined"
                    {...formik.getFieldProps('pincode')}
                    {...errorHelper(formik,'pincode')}
                />
            </div>

                    

            <Divider className='mt-3 mb-3'/>
            <div className='form-group'>
            <FormControl fullWidth>
            
                <InputLabel>Select your District</InputLabel>
                <Select
                    name="districtID"
                    label="Select your District"
                    {...formik.getFieldProps('districtID')}
                    error={ formik.errors.districtID && formik.touched.districtID ? true:false}
                >
                     <MenuItem value={1}><em>KOLAR</em></MenuItem>
                    <MenuItem value={2}>BENGALURU</MenuItem>
                </Select>
                { formik.errors.districtID && formik.touched.districtID ?
                    <FormHelperText error={true}>
                        { formik.errors.districtID}
                    </FormHelperText>
                :null
                }
            </FormControl>
</div>
            <Divider className='mt-3 mb-3'/>
            <div className='form-group'>
            <FormControl fullWidth>
                <InputLabel>Select your Taluk</InputLabel>
                <Select
                    name="talukID"
                    label="Select your talukID"
                    {...formik.getFieldProps('talukID')}
                    error={ formik.errors.talukID && formik.touched.talukID ? true:false}
                >
                    
                    <MenuItem value={1}><em>MALUR</em></MenuItem>
                </Select>
                { formik.errors.talukID && formik.touched.talukID ?
                    <FormHelperText error={true}>
                        { formik.errors.talukID}
                    </FormHelperText>
                :null
                }
            </FormControl>
</div>
       
 
            

                    
                    

            
            

           
           
                 

            
            <Divider className='mt-3 mb-3'/>
          
          
            { shop.loading ?
                    <Loader/>
                :
                <Button
                    variant='contained'
                    color="primary"
                    type="submit"
                >
                    Add Adress
                </Button>
                }

        </form>

        <div className='form-group'></div>
        <ButtonGroup className='me-2'>
                    <LinkContainer to={imgUrl}>
                        <Button 
                        variant='link'
                        color="orange"
                        >
                            Next
                            </Button>
                    </LinkContainer>
                </ButtonGroup>
       

        </>
    )

}

export default AddShopAdress;